import { getAxiosInstance } from '../api.client';
import {
    type ProjectTask,
    type ProjectTaskDetail,
    type ProjectTaskFormModel,
} from './projectTasks.models';

export async function getProjectTasks(
    projectId: string,
): Promise<ProjectTaskDetail[]> {
    const response = await getAxiosInstance().get<ProjectTaskDetail[]>(
        `/project/${projectId}/task`,
    );
    return response.data;
}

export async function getProjectTaskById(
    projectId: string,
    id: string,
): Promise<ProjectTaskDetail> {
    const response = await getAxiosInstance().get<ProjectTaskDetail>(
        `/project/${projectId}/task/${id}`,
    );
    return response.data;
}

export async function createProjectTask(
    projectId: string,
    data: ProjectTaskFormModel,
): Promise<ProjectTask> {
    const response = await getAxiosInstance().post<ProjectTask>(
        `/project/${projectId}/task`,
        data,
    );
    return response.data;
}

export async function updateProjectTask(
    projectId: string,
    id: string,
    data: ProjectTaskFormModel,
): Promise<ProjectTask> {
    const response = await getAxiosInstance().put<ProjectTask>(
        `/project/${projectId}/task/${id}`,
        data,
    );
    return response.data;
}

export async function deleteProjectTask(
    projectId: string,
    id: string,
): Promise<void> {
    await getAxiosInstance().delete(`/project/${projectId}/task/${id}`);
}

export interface CompleteProjectTaskRequest {
    completionDate?: string | null;
}

export async function completeProjectTask(
    projectId: string,
    id: string,
    data?: CompleteProjectTaskRequest,
): Promise<ProjectTask> {
    const response = await getAxiosInstance().post<ProjectTask>(
        `/project/${projectId}/task/${id}/complete`,
        data ?? {},
    );
    return response.data;
}

export async function reactivateProjectTask(
    projectId: string,
    id: string,
): Promise<ProjectTask> {
    const response = await getAxiosInstance().post<ProjectTask>(
        `/project/${projectId}/task/${id}/reactivate`,
    );
    return response.data;
}
